import { createContext, ReactNode, useContext } from "react";

function createContexor<T>() {
  const Context = createContext<T | undefined>(undefined);

  type Props = {
    item: T;
    children: ReactNode;
  };

  function Provider({ item, children }: Props) {
    return <Context.Provider value={item}>{children}</Context.Provider>;
  }

  function useContexor() {
    const context = useContext(Context);
    if (!context) {
      throw new Error("useContexor must be used within a Provider");
    }
    return context;
  }

  return { Provider, useContexor };
}

export default createContexor;
